export default {
  index: {
    rechargeGame: "상품 결제",
    quickRecharge: "빠른 결제",
    history: "역사 기록",
  },
  component: {
    history: {
      title: "최근 충전내역 자동 저장",
      loadingText: "데이터 로드 중",
      detail: {
        title: "주문번호 상세 내역",
        product_name: "상품항목",
        custom_content: "보상 내역",
        game_name: "게임",
        server_name: "서버",
        roleid: "캐릭터id",
        pay_title: "결제방식",
        money: "전액결제",
        order_id: "주문번호",
        pay_time: "시간",
        coupon_code: "코드",
        all_ratio: "증정 비율",
      },
      filters: {
        notRecharged: "미결제",
        rechargedSuccess: "주문 성공",
        rechargedError: "주문 실패",
      },
    },
    quickRecharge: {
      loadingText: "데이터 로드 중",
      title: "주문번호 상세 내역",
      product_name: "상품항목",
      custom_content: "보상 내역",
      game_name: "게임",
      server_name: "서버",
      roleid: "캐릭터id",
      pay_title: "결제방식",
      money: "전액결제",
      order_id: "주문번호",
      pay_time: "시간",
      coupon_code: "코드",
      all_ratio: "증정 비율",
      button: {
        rechargeOrder: "빠른 결제",
      },
    },
    rechargeGame: {
      loadingText: "데이터 로드 중",
      noDataText: "데이터 조회 불가",
      gameForm: {
        title: "캐릭터 정보",
        gamePlaceholder: "게임 선택",
        serverPlaceholder: "서버 선택",
        usernamePlaceholder: "캐릭터 닉네임",
      },
      infoForm: {
        title: "결제 정보",
        region: "지역 선택",
        placeholder: "지역 및 국가 선택",
      },
      typeForm: {
        title: "결제방식",
        placeholder: "선택",
        channelPlaceholder: "결제 수단을 선택해 주세요",
      },
      item: {
        title: "결제상품",
      },
      detail: {
        title: "빠른 결제", //
        game_name: "게임", //
        server_name: "서버", //
        roleid: "캐릭터id", //
        pay_title: "결제방식", //
        money: "전액결제", //
        product_title: "결제상품",
        custom_content: "보상 내역",
        remind_content: "알림",
        coupon_code: "선물코드", //
        couponCodePlaceholder: "사용할 쿠폰 코드를 입력하십시오",
        all_ratio: "증정 비율", //
        tips: "일괄 게임 코인 지급",
        button: "확인",
      },
      methods: {
        dataErrorMsg: "데이터 요청 오류",
        itemErrorMsg: "상품 선택",
        serverErrorMsg: "서버 에러",
        couponCodeSuccessMsg: "유효 코드",
      },
    },
  },
};
